import { render } from "./DailyDemand.vue?vue&type=template&id=6b0732c0&scoped=true"
import script from "./DailyDemand.vue?vue&type=script&lang=js"
export * from "./DailyDemand.vue?vue&type=script&lang=js"

import "./DailyDemand.vue?vue&type=style&index=0&id=6b0732c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0732c0"]])

export default __exports__